export default __webpack_public_path__ + "static/media/mal.73ac4354.png";